import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1',
    maxWidth: '100%'
  },

  tabs: {
    marginTop: '-0.5rem',
    marginBottom: '0.5rem',
    minHeight: 'unset'
  },

  tab: {
    padding: '0.5rem',
    fontSize: theme.size.sm,
    minWidth: 'unset',
    minHeight: 'unset'
  }
}))

export default useStyles
